import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { InlineWidget } from "react-calendly";

// Import supabase configuration
import supabase from '../config/supabase';
import { updateClientProfiles, getClientNotification } from '../redux/actions/actions';
import { useSelector, useDispatch } from "react-redux";

import Header from "../components/header/clientHeader";
import { Buffer } from "buffer";
import Skeleton from "react-loading-skeleton";
import { Oval } from "react-loader-spinner";
import moment from "moment";
import Avatar from "@mui/material/Avatar";
import Calendly from "../components/calendly/calendly";
import CalendlyReschedule from "../components/calendly/calendlyReschedule";
import { hotjar } from 'react-hotjar';
import mixpanel from 'mixpanel-browser';

// Import router from next
import { useNavigate } from "react-router-dom";

// testing token
// const token = 'Bearer '+'eyJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL2F1dGguY2FsZW5kbHkuY29tIiwiaWF0IjoxNjI1ODE1MjAxLCJqdGkiOiI5ZjBlZTlhYy1lM2ZhLTQ1MjEtOWJjYy1mNDUxYjQ4MWQwN2YiLCJ1c2VyX3V1aWQiOiJGRERCUzVWTEhYNUJVV0JRIn0._pUHaYDAX5DhxDoGj4sV17CVRqv91p5rh3P53dleKdI'; 

// live token
const token = 'Bearer '+'eyJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL2F1dGguY2FsZW5kbHkuY29tIiwiaWF0IjoxNjQ5MDg1NzE0LCJqdGkiOiJkYjhhMDI2NS03Nzk2LTRiZTYtYjdjZi1mM2NhY2YxYzlmNjciLCJ1c2VyX3V1aWQiOiJERUVETUJZRzVZQUJNUDdYIn0.q2St3KwElJAUq3gRAxBKM1mD88I2C80ccrw4bAi3CWI'; 

function CalendlyPage() {

    const navigate = useNavigate();
	const dispatch = useDispatch();

	const { clientNotification } = useSelector((state) => state.client);

	const [clientProfiles, setClientProfiles] = useState([]);
	const [notifications, setNotifications] = useState({});
	const [profile, setProfile] = useState({});
	const [showLoader, setShowLoader] = useState(true);
	const [urlWithToken, setUrlWithToken] = useState("");
	const [meetingScheduled, setMeetingScheduled] = useState(false);
	const [calendlyURL, setCalendlyURL] = useState('');
	const [currentAgenda, setCurrentAgenda] = useState([]);
	const [toHomeUrl,setToHomeUrl] = useState("");
	const [loading, setLoading] = useState(false);

	useEffect( () => {
		return async() => {
			window.addEventListener("beforeunload", beforUnload());
		}
	  }, [])

	  async function beforUnload() {
		// var url = new URL(window.location.href);
		// var client_invitation_id = url.searchParams.get("client");
		// client_invitation_id = Buffer.from(client_invitation_id || "", "base64").toString("utf-8");
		var client_invitation_id = localStorage.getItem('clientid');
		var profiles = await getBoardProfiles(client_invitation_id)
		  console.log(client_invitation_id)
		  if(profiles?.length > 0){
			const options = {
				method: 'GET',
				// url: 'https://v1.nocodeapi.com/needu531/calendly/UuhqsxSfkwhnndJA/invitees?uuid=de61489e-5eaa-41e0-bbd0-a2450bdaba20',
				url: `https://api.calendly.com/scheduled_events/${profiles[0].event_uuid}/invitees`,
				headers: {
					'Content-Type': 'application/json',
					Authorization: token
				}
			  };
			  
			  axios.request(options).then(async function (response) {
				console.log(response.data.collection[0]);
				console.log(response.data.collection[0].rescheduled);
			  if(response.data.collection[0].rescheduled){
				  fetchDateTime(response, profiles)
			  }
			  else {
				  localStorage.removeItem('clientid')
			  }
			})
		}

	  }

	async function fetchDateTime(value, profiles) {
		// Get profile id
		// setMeetingScheduled(true);
		// setShowLoader(true);
		// var profile_id = localStorage.getItem("clientBoardProfile");

		// var client = await getClient("profiles");
		
		var cancel_url = '';
		var reschedule_url = '';
		var event_uuid = '';
		var startTime = '';
		var endTime = '';
		var meetingUrl = '';
		console.log(value.data.collection[0].new_invitee);
		var url = new URL(value.data.collection[0].new_invitee);
		url = url.pathname.split('/')
		console.log(url[2]);
		const options2 = {
		method: 'GET',
		// url: 'https://v1.nocodeapi.com/needu531/calendly/UuhqsxSfkwhnndJA/invitees?uuid=de61489e-5eaa-41e0-bbd0-a2450bdaba20',
		url: `https://api.calendly.com/scheduled_events/${url[2]}`,
		headers: {
			'Content-Type': 'application/json',
			Authorization: token
		}
		};
		axios.request(options2).then(function (response) {
			console.log(response.data.resource);

			event_uuid = new URL(response.data.resource.uri);
			event_uuid = event_uuid.pathname.split('/');
			event_uuid = event_uuid[2];
			startTime = response.data.resource.start_time;
			endTime = response.data.resource.end_time;
			meetingUrl = response.data.resource.location.join_url;

			const options = {
				method: 'GET',
				url: `${response.data.resource.uri}/invitees`,
				headers: {
					'Content-Type': 'application/json',
					Authorization: token
				}
			};
			axios.request(options).then(async function (res) {
				console.log(res)
				console.log(res.data.collection[0].cancel_url);
				console.log(res.data.collection[0].reschedule_url);
				cancel_url = res.data.collection[0].cancel_url;
				reschedule_url = res.data.collection[0].reschedule_url;
				var client_invitation_id = localStorage.getItem('clientid');
				var client_profiles = JSON.parse(localStorage.getItem('clientProfiles'));
				console.log(client_profiles);
				updateMeetingTime(startTime,endTime, client_profiles, client_invitation_id, cancel_url, reschedule_url, event_uuid, meetingUrl, profiles)
			})
		})
	}
	
	useEffect(async () => {
		document.title = "Reschedule interview";
		mixpanel.init('de405b9420bcdeddec4d225dc80801ec'); 
		hotjar.initialize(2875931, 6);

		// Get profile id
		var profile_id = localStorage.getItem("clientBoardProfile");

		var url = new URL(window.location.href);
		var client_invitation_id = url.searchParams.get("client");
		client_invitation_id = Buffer.from(client_invitation_id || "", "base64").toString("utf-8");
		localStorage.setItem('clientid', client_invitation_id)
		var profiles = await getBoardProfiles(client_invitation_id)
			if(profiles?.length > 0){
				setCurrentAgenda(profiles);
				const options = {
					method: 'GET',
					// url: 'https://v1.nocodeapi.com/needu531/calendly/UuhqsxSfkwhnndJA/invitees?uuid=de61489e-5eaa-41e0-bbd0-a2450bdaba20',
					url: `https://api.calendly.com/scheduled_events/${profiles[0].event_uuid}/invitees`,
					headers: {
						'Content-Type': 'application/json',
						Authorization: token
					}
				  };
				  
				  axios.request(options).then(function (response) {
					console.log(response.data.collection[0]);
					console.log(response.data.collection[0].rescheduled);
				  if(response.data.collection[0].rescheduled){
					window.addEventListener("beforeunload", fetchDateTime);
				  }
				})
			}
			// });
			// getProfileDetails(profile_id);
			getNotifications();
			localStorage.setItem("flag", true);
			return () => {
				console.log('component will mount')
				window.removeEventListener("beforeunload", fetchDateTime);
			};
	}, []);

	useEffect( () => {
		var url = new URL(window.location.href);
		var calendly = url.searchParams.get("calendlyUrl");
		calendly = Buffer.from(calendly || "", "base64").toString("utf-8");
		setCalendlyURL(calendly);
	},[]);

	useMemo(() => {
		return () => {
			console.log('component will mount')
			window.addEventListener("beforeunload", fetchDateTime);
		};
	  },[]);

	const getBoardProfiles = async (id) => {
		var client = [];
	
		// if (token) {
		  var { data, error } = await supabase
			.from("board_clients_invitation")
			.select("*")
			.match({ id: id});
	
		  if (data && data.length) {
			client = data;
			setClientProfiles(data[0].profiles);
			localStorage.setItem('clientProfiles', JSON.stringify(data[0].profiles))
			let homeUrl = data[0].url_with_token
			homeUrl = homeUrl.split("id")[1]
			setToHomeUrl(homeUrl)
			var { data, error } = await supabase
			.from("notifications")
			.select("*")
			.order('created_at', { ascending: false })
			.match({client: id});
			
			if(data && data.length){
			  var meetings = data;
			  meetings.map((m,index)=> {
				let date  = m.created_at && new Date(m.created_at);
				let newDate = date && new Date(date.getTime() - date.getTimezoneOffset()*60*1000);
				var end = newDate ? moment(newDate).format('h:mm A') : "";
				m.time = end;
			   
				var today = new Date();
				var yesterday = new Date(today);
	
				yesterday.setDate(yesterday.getDate() - 1);
	
				var checkDay = new Date(today);
	
				checkDay.setDate(checkDay.getDate() - 6);
	
				if((date.getMonth() == today.getMonth()) && (date.getDate() == today.getDate())){
				  m.day = "Today"
				}
				else if((date.getMonth() == yesterday.getMonth()) && (date.getDate() == yesterday.getDate())){
				  m.day = "Yesterday"
				}
				else if((date.getMonth() >= checkDay.getMonth()) && (date.getDate() == checkDay.getDate())){
				  var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
				  var d =days[date.getDay()];
	  
				  m.day = d ;
				}
				else{
				  m.day = moment(date).format('MMM Do');
				}
			  })
			 
			  setNotifications(meetings);
			}
		  }
		var sameAgendaProfiles = [];
	
		var profiles =
		  client.length && client[0].profiles
			? await getAllProfiles(client[0].profiles)
			: [];
			profiles.map(async (profile) =>{
			  for(let index = 0; index < client[0]?.profiles?.length; index++){
				// For email user/ priavte user
				if(profile.id == client[0].profiles[index].id ){
	
				  if(client[0].profiles[index].meetingTime){
					// Start meeting time
					let date  = new Date(client[0].profiles[index].meetingTime);
					profile.meetingTime = moment(date).format('MMM D, h:mm A');
					var meetingDate = moment(date).format('dddd, MMMM D YYYY');
					meetingDate = meetingDate.split(' ');
					meetingDate[2] = meetingDate[2].concat("'");
					meetingDate = meetingDate.join(' ')
					profile.meetingDate = meetingDate;
					
					profile.fullMeetingTime = moment(date).format('ddd MMM D YYYY HH:mm:ss');
	
					// End meeting time
					let endDate  = client[0].profiles[index].endMeetingTime && new Date(client[0].profiles[index].endMeetingTime);
					profile.endMeetingTime = endDate ? moment(endDate).format('h:mm A') : "";
					profile.bgColor = client[0].profiles[index].bgColor;
				  }
				  else{
					profile.meetingTime = client[0].profiles[index].meetingTime;
					profile.endMeetingTime = client[0].profiles[index].endMeetingTime;
					profile.bgColor = client[0].profiles[index].bgColor;
	
				  }
				}
	
				// Client hourly rate
				if(profile.id == client[0].profiles[index].id){
					profile.client_hourly_rate = client[0].profiles[index].rate;
				}
			  }
			})
		  var tempMeetingTimeArray = [];
		  profiles.forEach((prof)=>{
		  if(prof.meetingTime.length > 0){
			  if(tempMeetingTimeArray?.findIndex((el) => el === prof.meetingTime) === -1){
				tempMeetingTimeArray.push(prof.meetingTime)
			  }
			}
		  })
		  var sameAgendaProfiles = [];
		  var currentAgenda = [];
		  tempMeetingTimeArray.forEach( (el) => {
			var tempArray = [];
			tempArray = profiles.filter( (profile) => profile.meetingTime === el )
			sameAgendaProfiles.push(tempArray);
		  })
			sameAgendaProfiles.forEach( (profiles) => {
			  var date = new Date();
			  var d =  moment(date).format('ddd MMM D YYYY HH:mm:ss');
			  var res = moment(profiles[0].fullMeetingTime).isSameOrAfter(d);
			  if(res){
				currentAgenda= profiles;
			  }
			})
		setShowLoader(false);
		setLoading(false);
		return currentAgenda
	  };

	  const getAllProfiles = async (ids) => {
		var allIds = [];
		var all_profiles = [];
		ids.forEach( (id) => {
		  allIds.push(id.id);
		})
		  const { data, error } = await supabase
		  .from("all_profiles")
		  .select("*")
		  .in('id', allIds);
	
		  if(data && data.length > 0) {
			ids.forEach( (val,index) => {
			  data.forEach((profileValue, i) => {
				if(val.id == profileValue.id){
				var profile = { ...data[i], status: ids[index].status, meetingTime: ids[index].meetingTime, cancelUrl: ids[index].cancel_url ? ids[index].cancel_url : '', rescheduleUrl: ids[index].reschedule_url ? ids[index].reschedule_url : '', event_uuid: ids[index].event_uuid ? ids[index].event_uuid : '' ,
				meetingUrl: ids[index].meetingUrl ? ids[index].meetingUrl : '' };
				all_profiles.push(profile);
				}
			  })
			  // }
			})
			return all_profiles
		  } else {
			console.log('no profiles');
		  }
	  };

	const getClient = async(check) => {
		// get client invitation id
		var url = new URL(window.location.href);
		var clientInvitationId = url.searchParams.get("client");
		var client_invitation_id = Buffer.from(clientInvitationId || "", "base64").toString("utf-8");
		
		if(client_invitation_id)
		{
			if(check == "profiles"){
				var client = await getclientProfiles(client_invitation_id, "profiles");
				setClientProfiles(client.profiles);
				return {
					'profiles' : client.profiles,
					'clientId' : client_invitation_id,
					"clientEmail" : client.email,
				}
			}
			else{
				const url = await getclientProfiles(client_invitation_id, "url");
				return {
					"url" : url, "client_id" : client_invitation_id
				}
			}
		}
	}


	async function updateMeetingTime(startTime, endTime, tempClientProfiles ,clientId, cancel_url,  reschedule_url, event_uuid, meeting_url, current_Agenda){
		var profiles = tempClientProfiles.map((profile)=>{
				var newValue = profile
				current_Agenda.forEach((currentProfile) => {
					if(currentProfile.id === profile.id){
						newValue.meetingTime = startTime;
						newValue.endMeetingTime = endTime;
						newValue.reschedule_url = reschedule_url;
						newValue.cancel_url = cancel_url;
						newValue.event_uuid = event_uuid;
						newValue.meetingUrl = meeting_url;
					}
				})
			// let color = getRandomColor();
				// profile.bgColor = color;
				return newValue
		})
		// setMeetingScheduled(true);
		// var { data, error } = await supabase
        // .from("board_clients_invitation")
        // .update({profiles: profiles})
        // .match({ id: clientId });

		dispatch(updateClientProfiles(profiles, clientId))
		.then( async() => {
			console.log('update done')
			let date  = new Date(startTime);
			var start = moment(date).format('MMMM Do, h:mm A') ;

			// End meeting time
			let endDate  = endTime && new Date(endTime);
			var end = endDate ? moment(endDate).format('h:mm A') : "";

			var name = current_Agenda[0].full_name ? current_Agenda[0].full_name.split(" ")[0] : "Akira";
			var message =''
			if(current_Agenda.length > 1) {
				var count = current_Agenda.length-1;
				message = "You have Rescheduled a meeting with " + name  + "'s & " + count + " more recruitment manager; " + start + " - " + end;
			} else {
				message = "You have Rescheduled a meeting with " + name  + "'s recruitment manager; " + start + " - " + end;
			}
			await insertNotifications(clientId,message)
			.then( () => {
				
				localStorage.removeItem('clientid');
				localStorage.removeItem('clientProfiles');
				console.log('success')
				localStorage.removeItem("loggedIn");
			})
		})

	}

	const insertNotifications = async(clientId,message) => {
		// localStorage.removeItem("flag");

		var profile_id = localStorage.getItem("clientBoardProfile");

		var { data, error } = await supabase
		.from("notifications")
		.select("*")
		.match({client: clientId, message: message,profileId:profile_id})

		if(data && data.length <= 0){
			let flag = localStorage.getItem("flag");
			if(flag == "true"){
				localStorage.removeItem("flag");
				var { data, error } = await supabase
				.from("notifications")
				.insert({client: clientId, message: message,profileId:profile_id})
		
				if(data && data.length){
					localStorage.setItem("showNumber",true);
					await getNotifications();
					setShowLoader(false);
				}
			}else{
				await getNotifications();
				setShowLoader(false);
			}
		}
	}

	const getclientProfiles = async(id, check) => {
		var { data, error } = await supabase
        .from("board_clients_invitation")
        .select("*")
        .match({ id: id });

      if (data && data.length) {
		  setUrlWithToken(data[0].url_with_token);
		  if(check == "profiles"){
			return {
				'profiles':data[0].profiles,
				'email': data[0].email,
			}
		  }
		  else{
			return data[0].url_with_token;
		  }
      }
	}

	async function getNotifications(){
		var client_invitation_id = localStorage.getItem('clientid');
		
		dispatch(getClientNotification(client_invitation_id))

		// if(data && data.length){
        //   let meetings = data;
        //   meetings.map((m,index)=> {
        //     let date  = m.created_at && new Date(m.created_at);
		// 	let newDate = date && new Date(date.getTime() - date.getTimezoneOffset()*60*1000);
        //     var end = newDate ? moment(newDate).format('h:mm A') : "";
        //     m.time = end;
			
        //     var today = new Date();
        //     var yesterday = new Date(today);

        //     yesterday.setDate(yesterday.getDate() - 1);

        //     var checkDay = new Date(today);

        //     checkDay.setDate(checkDay.getDate() - 6);

        //     if((date.getMonth() == today.getMonth()) && (date.getDate() == today.getDate())){
        //       m.day = "Today"
        //     }
        //     else if((date.getMonth() == yesterday.getMonth()) && (date.getDate() == yesterday.getDate())){
        //       m.day = "Yesterday"
        //     }
        //     else if((date.getMonth() >= checkDay.getMonth()) && (date.getDate() == checkDay.getDate())){
        //       var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        //       var d =days[date.getDay()];
  
        //       m.day = d ;
        //     }
        //     else{
        //       m.day = moment(date).format('MMM Do');
        //     }
        //   })
        //   setNotifications(meetings);
        // }
		// setMeetingScheduled(true);
	}

	async function getProfileDetails(profileId){
		var { data, error } = await supabase
        .from("all_profiles")
        .select("*")
        .match({ id: profileId });

		setShowLoader(false);

		if (data && data.length) {
			setProfile(data[0]);
			return data[0]
		}
	}
	

	async function toCandidates(){
		mixpanel.track('toOtherCandidates');

		// const options = {
		// 	method: 'GET',
		// 	// url: 'https://v1.nocodeapi.com/needu531/calendly/UuhqsxSfkwhnndJA/invitees?uuid=de61489e-5eaa-41e0-bbd0-a2450bdaba20',
		// 	url: `https://api.calendly.com/scheduled_events/${currentAgenda[0].event_uuid}/invitees`,
		// 	headers: {
		// 		'Content-Type': 'application/json',
		// 		Authorization: token
		// 	}
		//   };
		  
		//   axios.request(options).then(function (response) {
		// 	console.log(response.data.collection[0]);
		// 	console.log(response.data.collection[0].rescheduled);
		// 	if(response.data.collection[0].rescheduled){
		// 		fetchDateTime(response);
		// 	}
		// })

		if(urlWithToken){
			localStorage.removeItem("loggedIn");
			const url = urlWithToken.split("client")[1];
			navigate(`/client${url}`);
		}
		else{
			var url = new URL(window.location.href);
			var clientInvitationId = url.searchParams.get("client");
			
			if(clientInvitationId){
				localStorage.removeItem("loggedIn");
				let client = await getClient("url");
				url = client?.url.split("client")[1];
				navigate(`/client${url}`);
			}
			else{
				url = window.location.href.split("board")[1];
				navigate(`/client?id${url}`);
			}
		}
		
	} 

	return (
		<div className="w-full ">

			{/* Add header */}
			<Header loading={(value) => setShowLoader(value)} justView={localStorage.getItem("supabase.auth.token") ? false : true} showLogin={localStorage.getItem("supabase.auth.token") ? false : true} getClient={getClient} notifications={notifications}>

			{showLoader && (
				<div className="fixed flex items-center justify-center z-10 w-full h-full top-0 bg-white-1">
				{/* Add backdrop */}
				
				<div className={`relative flex`}>
					<Oval
						color="white"
						secondaryColor="grey"
						height="40"
						width="60"
					/>
					<div className="flex items-center">Hold Tight-just getting this page ready.</div>
				</div>
				</div>
			)}

			<div className="md:hidden bg-[#F1F2F5] px-5 pt-5">
				{
					meetingScheduled ? <div className="flex">
							<p onClick={() => toCandidates()} className="col-span-2 text-white-1 p-2 rounded text-sm bg-pink-1">Back to candidates </p>
						</div>
					: 
				<div className="flex cursor-pointer " onClick={() => toCandidates()}>Back to board 
					{/* <svg className="ml-3" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M12.172 12L9.343 9.172l1.414-1.415L15 12l-4.243 4.243-1.414-1.415z" fill="rgba(255, 73, 116, 1)"/></svg> */}
				</div>
				}
			</div>
				<div className="grid grid-cols-12 gap-0 sticky bg-[#F1F2F5] md:bg-white-1">
					<div className="md:col-span-8 col-span-12 md:pt-10 h-screen m-5 md:m-0">
						<CalendlyReschedule onSchedule={fetchDateTime} calendlyURL={calendlyURL} />
					</div>
					
					<div className="hidden md:block md:col-span-4 bg-blue-7 relative">
						<div className="flex flex-col items-center justify-center pt-28 pb-5">
							{/* Show image */}
							<img src="/calendly.png" className="" />
							{/* Show text */}
							{
								meetingScheduled ? <div className="font-bold text-left mx-5 xl:mx-8 xl-3:mx-16 text-3xl mt-16">
									Your meeting has been scheduled with recruiting manager
							</div> :
								<div className="font-bold text-left mx-5 xl:mx-8 xl-3:mx-16 text-3xl mt-16">
								{`Edit your meeting details with recruitment manager`}
							</div>
							}
							
							<div className="absolute -left-16 mb-36">
								<img src="/arrow.png" />
							</div>

							{/* Add card */}
							<div className="w-10/12 mt-8 mb-6 text-black-4 font-poppins">
								<div className="">Candidates booked: </div>
							</div>
							<div className="flex">
								{
									currentAgenda?.length > 0 &&
									currentAgenda.slice(0,2).map( (profile, index) => (
										<div key={index} className="">
											<div className='flex justify-center'>
												<div className={`w-[60px] h-[60px] flex items-center justify-center rounded-full hover:border-blue-4 cursor-pointer mb-4 ml-2`} >
													<Avatar alt="Profile" src={profile.emoji_url} className="" imgProps={ {'style':{'objectFit': 'contain'}}} />
												</div>
											</div>
											
											<div  className={`w-28 text-center text-black-1 text-sm p-1 ml-2 mb-4 rounded-sm border-blue-1  border font-medium`}>
												{profile.full_name?.split(' ')[0]}
											</div>  
										</div>
									))
								}
								{currentAgenda.length > 2 &&
									<div>
										<div className="flex justify-center">
											<div className={`w-[60px] h-[60px] flex items-center justify-center rounded-full hover:border-blue-4 cursor-pointer mb-4 ml-2`} >
												<Avatar alt="Profile" src='user1.png' className="" imgProps={ {'style':{'objectFit': 'contain'}}} />
											</div>
										</div>
										<div  className={`w-28 text-center text-black-1 text-sm p-1 ml-2 mb-4 rounded-sm border-blue-1 border font-medium`}>
											+ {currentAgenda.length-2} more
										</div>
									</div> 
								}
							</div>
							{
								meetingScheduled ? <div className="pb-10" onClick={() => toCandidates()}>
									<div className="font-semibold flex items-center text-white-1 mt-20 p-4 rounded cursor-pointer text-sm bg-pink-1">View other candidates </div> </div>
							 : 
							<div className="font-semibold flex text-blue-4 mt-20 cursor-pointer " onClick={() => toCandidates()}>Add another candidate
								<svg className="ml-3" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M12.172 12L9.343 9.172l1.414-1.415L15 12l-4.243 4.243-1.414-1.415z" fill="rgb(32,78,207)"/></svg>
							</div>
							}
							
						</div>
					</div>
				</div>
			</Header>
			
		</div>
	);
};

export default CalendlyPage;